import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { statusTranslationMap, getStatusColor } from '../..//statusUtils'
import { getVehicleTypeLabel, formatEventVehicleDimensions } from '@/utils/vehicle';
import { useTranslation } from 'react-i18next';

const LastEventChip = ({
  lastEvent
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        position: 'absolute',
        left: 16,
        bottom: 12,
        zIndex: 3,
        px: 1.25,
        py: 0.75,
        borderRadius: 1.5,
        bgcolor: 'rgba(0,0,0,0.70)',
        color: '#fff',
        lineHeight: 1.25,
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(255,255,255,0.1)'
      }}
    >
      {lastEvent.plate_number && (
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 700, mb: 0.5 }}
        >
          {lastEvent.plate_number}
        </Typography>
      )}
      {lastEvent.type && (
        <Typography
          variant="caption"
          sx={{
            display: 'inline-block',
            px: 0.75,
            py: 0.25,
            borderRadius: 999,
            mb: 0.75,
            bgcolor:
              getStatusColor(lastEvent.type) === 'green'
                ? 'rgba(76,175,80,0.3)'
                : 'rgba(244,67,54,0.3)',
            border: `1px solid ${
              getStatusColor(lastEvent.type) === 'green'
                ? 'rgba(76,175,80,0.5)'
                : 'rgba(244,67,54,0.5)'
            }`
          }}
        >
          {t(statusTranslationMap[lastEvent.type] || lastEvent.type)}
        </Typography>
      )}
      {
        lastEvent.vehicle_type && 
        <VehicleTypeDisplay type={lastEvent.vehicle_type}/>
      }
      {
        hasVehicleDimensions(lastEvent) && (
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              mt: 0.5,
              fontSize: '0.7rem',
              fontFamily: 'monospace'
            }}
          >
            { formatEventVehicleDimensions(lastEvent) }
          </Typography>
        )
      }
    </Box>
  )
}

const hasVehicleDimensions = (event) => (
  !event.vehicle_type &&
  event.vehicle_length_mm ||
  event.vehicle_width_mm ||
  event.vehicle_height_mm
)

const VehicleTypeDisplay = ({ type }) => {
  const { t } = useTranslation();
  if (!type) return null
  return (
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        mt: 0.5,
        opacity: 0.95,
        fontSize: '0.7rem',
        color: 'rgba(255,255,255,0.9)'
      }}
    >
      {t('vehicle_type')}: {getVehicleTypeLabel(type, t)}
    </Typography>
  )
}

export default LastEventChip